import styled from '@emotion/styled';
import theme from '../../../shared/theme';
import FilterCheckboxes from '../FilterCheckboxes/FilterCheckboxes';

export const MAX_CHART_WIDTH = 496;
export const SMALL_CHART_WIDTH = 384;

/** Gap between the bars of the same year */
export const BAR_GAP = 10;

/** The maximum width of one bar */
export const BAR_WIDTH = 64;
export const BAR_WIDTH_SMALL = 46;

/** The extra width of the label in relation to the bar width */
export const LABEL_WIDTH_EXTRA = 4;

/** The height of the label below the bar */
export const LABEL_HEIGHT = 40;
export const LABEL_HEIGHT_SMALL = 60;

export type BarSizes = {
  barWidth: number,
  barGap: number,
  labelWidth: number,
  labelHeight: number,
};

export const getBarSizes = (chartWidth: number): BarSizes => {
  const isSmall = chartWidth <= SMALL_CHART_WIDTH;
  const barWidth = isSmall ? BAR_WIDTH_SMALL : BAR_WIDTH;
  const labelHeight = isSmall ? LABEL_HEIGHT_SMALL : LABEL_HEIGHT;
  const labelWidth = barWidth + LABEL_WIDTH_EXTRA;
  return {
    barGap: BAR_GAP,
    barWidth,
    labelWidth,
    labelHeight,
  };
};

export const Container = styled.div({
  position: 'relative',
  height: '100%',
  width: '100%',
  maxWidth: MAX_CHART_WIDTH,
  margin: '0 auto',
  '& .recharts-tooltip-wrapper': {
    zIndex: 16,
  },

  '.bar-name': {
    textAlign: 'center',
    fontSize: '0.625rem',
    lineHeight: '1rem',
  },
});

export const FilterWrapper = styled.div({
  textAlign: 'center',
});

export const StyledFilterCheckboxes = styled(FilterCheckboxes)({
  display: 'inline-block',
});

export const barColor = theme.colors.darkBlue;
